// src/store/index.js
import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 在这里定义你真正需要的全局变量
    userInfo: {
      accessToken: '',
      refreshToken: '',
      id: '',
      name: '',
      role: '',
      lastLoginTime: '',
    }
  },
  getters: {
    getUserInfo(state) {
      return state.userInfo
    },
    getAccessToken(state) {
      return state.userInfo?.accessToken ?? ''
    },
    getRefreshToken(state) {
      return state.userInfo?.refreshToken ?? ''
    },
    getUserId(state) {
      return state.userInfo?.id ?? ''
    },
    getUserName(state) {
      return state.userInfo?.name ?? ''
    },
    getUserRole(state) {
      return state.userInfo?.role ?? ''
    },
    getLastLoginTime(state) {
      return state.userInfo?.lastLoginTime ?? ''
    }
  },
  mutations: {
    // 定义修改 state 的方法
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo || { accessToken: '', refreshToken: '', id: '', name: '', role: '', lastLoginTime: '' }
    },
    setUserName(state, name) {
      if (state.userInfo) state.userInfo.name = name
    },
    setAccessToken(state, accessToken) {
      if (state.userInfo) state.userInfo.accessToken = accessToken
    },
    setRefreshToken(state, refreshToken) {
      if (state.userInfo) state.userInfo.refreshToken = refreshToken
    }
  },
  actions: {
    // 定义异步操作
  },
  modules: {
    // 不再引入任何模块
  },
  plugins: [
    createPersistedState({
      paths: ['userInfo']
    })
  ]
})